import {alias, createModelSchema, custom, deserialize, serialize, SKIP} from "serializr";
import {Cloneable} from "@/common/Cloneable";
import {Schema} from "@/common/Schema";


export class PlinkoPhysicsConfig extends Cloneable {



    static schema() {
        return custom((v) => {
            return v && !v.empty() ? serialize(PlinkoPhysicsConfig, v) : SKIP;
        }, (v) => {
            return deserialize(PlinkoPhysicsConfig, v);
        });
    }

    constructor() {
        super();
        this._mass = 0;
        this._density = 0.1;
        this._friction = 0.5;
        this._restitution = 0.5;
        this._velocityLimit = 0;
    }

    get mass() {
        return this._mass;
    }

    set mass(value) {
        this._mass = value;
    }

    get density() {
        return this._density;
    }

    set density(value) {
        this._density = value;
    }

    get friction() {
        return this._friction;
    }

    set friction(value) {
        this._friction = value;
    }

    get restitution() {
        return this._restitution;
    }

    set restitution(value) {
        this._restitution = value;
    }

    get velocityLimit() {
        return this._velocityLimit;
    }

    set velocityLimit(value) {
        this._velocityLimit = value;
    }

    valid() {

        if (Number.isNaN(this.mass) || this.mass < 0) {
            return false;
        }

        if (Number.isNaN(this.density) || this.density < 0) {
            return false;
        }

        if (Number.isNaN(this.friction) || this.friction < 0) {
            return false;
        }

        if (Number.isNaN(this.restitution) || this.restitution < 0) {
            return false;
        }

        if (Number.isNaN(this.velocityLimit) || this.velocityLimit < 0) {
            return false;
        }

        return true;
    }

    empty() {
        //default
        return this.density === 0.1 && this.friction === 0.5 && this.restitution === 0.5;
    }

    clone(target = undefined) {
        if (!target) {
            return super.clone(new PlinkoPhysicsConfig());
        } else if (target instanceof PlinkoPhysicsConfig) {
            return super.clone(target);
        } else {
            console.assert(false);
            return undefined;
        }
    }
}

createModelSchema(PlinkoPhysicsConfig, {
    _mass: alias("mass", Schema.primitive()),
    _density: alias("density", Schema.primitive()),
    _friction: alias("friction", Schema.primitive()),
    _restitution: alias("restitution", Schema.primitive()),
    _velocityLimit: alias("velocity_limit", Schema.primitive())
});